import MapContext from 'context/map-context'

import SplitMapContext from 'context/split-map-context'
export default function useMap(mapRef = 'map') {
  // Both contexts are read unconditionally so the hook order stays stable when
  // mapRef varies between renders; the unused one is undefined outside its
  // provider, which the branches below already tolerate.
  const mapContext = React.useContext(MapContext)
  const splitMapRefs = React.useContext(SplitMapContext)

  if (mapRef === 'map_a' || mapRef === 'map_b') {
    return splitMapRefs[mapRef]
  }
  return mapContext
}
